module.exports = ".disabled {\r\n    background-color: #eee;\r\n}\r\n\r\n.display-qrcode {\r\n    height: 100%;\r\n    text-align: center;\r\n    padding: 15px\r\n}\r\n\r\n.display-qrcode canvas:first-child {\r\n    height: 100% !important;\r\n    max-width: 600px;\r\n    max-height: 600px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/modal/client-detail/device-info/device-info.component.css
// module id = ./src/app/app_manager/modal/client-detail/device-info/device-info.component.css
// module chunks = main